import CoreForm from "../../../../../../../web-v2/components/CoreForm";
import {TextFieldController} from "../../../../../../../web-v2/components/forms/TextFieldController";
import React, {useEffect} from "react";
import {PickerFieldController} from "../../../../../../../web-v2/components/PickerFieldController";
import {UserRoles} from "../../../../../../../../store/data/users/user-roles";
import {useForm} from "react-hook-form";
import {UserManageForm} from "../../../../../../../../store/data/users/user-manage-form";
import { SwitchFieldController } from "../../../../../../../web-v2/components/SwitchFieldController";

interface WebUsersManageForm {
  user: any;
  onSubmit: (data: any) => void;
}

export default function WebUsersManageForm({user, onSubmit}: WebUsersManageForm) {
  const form = useForm<UserManageForm>({
    defaultValues: {
      id: null,
      name: "",
      email: "",
      password: "",
      confirmPassword: "",
      role: 'Helpdesk',
      lockoutEnabled: false,
    }
  });
const selectedRole = form.watch("role"); 
  useEffect(() => {
    if (user) {
      form.setValue("id", user.id);
      form.setValue("name", user.name);
      form.setValue("email", user.email);
      form.setValue("role", user.role);
      form.setValue("lockoutEnabled", user.lockoutEnabled);
    }
  }, [user]);


  const handleOnSubmit = () => {
    if(selectedRole !== 'ExternalTechnician') {
      form.setValue('lockoutEnabled', false);
    }
    form.handleSubmit(onSubmit)();
  }
  

  return (
    <CoreForm form={form} onSubmit={handleOnSubmit}>
      <CoreForm.Row>
        <TextFieldController
          controlName='name'
          title='Name'
          required
        />
        <TextFieldController
          controlName='email'
          title='Email'
          required
        />
        <PickerFieldController
          controlName='role'
          title='Role'
          required
          defaultFirst={false}
          items={UserRoles.map(item => ({
            label: item.label,
            value: item.value
          }))}
        />
      </CoreForm.Row>
      {(user || selectedRole !== "ExternalTechnician") && (
        <CoreForm.Row>
          <TextFieldController
            placeholder={user ? 'Unchanged' : ''}
            controlName='password'
            title='Password'
            required={!user}
          />
          <TextFieldController
            placeholder={user ? 'Unchanged' : ''}
            controlName='confirmPassword'
            title='Confirm Password'
            required={!user}
          />
        </CoreForm.Row>
      )}
      {user && selectedRole === "ExternalTechnician" && (
        <CoreForm.Row>
          <SwitchFieldController
            controlName="lockoutEnabled"
            title="Locked out"
          />
        </CoreForm.Row>
      )}
    </CoreForm>
  )
}
